/* eslint-disable import/first */

/**
 * Install sentry error tracking
 */
import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: 'https://bbf3729ef260452eaf1b588d33aeb981@sentry.io/141630',
  release: `create-app-${__VERSION__}`,
});

import { Query } from 'acast-reactor';
import * as Utils from 'acast-www-utils';
import Config from 'app/config';
import Cookie from 'app/cookie';
import Dispatch from 'app/dispatch';
import log from 'app/log';
import Session from 'app/session';
import immutable from 'immutable';
import { checkDeprecated } from 'lib/deprecate';
import { browserHistory } from 'react-router';
import Auth from 'services/authentication';
import Modal from 'shared/components/modal';
import Request from 'superagent';
import render from './render';

Config.set('VERSION', __VERSION__);

/**
 *  Next up, we will define our global DEBUG flag on the window before
 *  loading any other scripts.
 */
if (__DEBUG__ || window.location.host.match('(systemtest|localhost|-stage.azurewebsites.net)')) {
  Config.set('DEBUG', true);
} else {
  Config.set('DEBUG', false);
}

/**
 * Initialize the authentication client
 */
Auth.init({
  host: Config.get('AUTH_HOST'),
  request: Request,
  cookie: Cookie,
});

/**
 * If we are in debug mode, expose some of our code on the window
 * object so that we can easily debug from the console
 */
if (Config.get('DEBUG')) {
  // eslint-disable-next-line no-underscore-dangle
  window._acast = {
    Dispatch,
    Config,
    Cookie,
    Auth,
    Session,
    Query,
    Utils,
    immutable,
    Modal,
    log,
  };
}

/**
 *  We are now ready for any client-side code. You should now start editing
 *  the routes file to add your custom routes.
 */
document.addEventListener('DOMContentLoaded', () => {
  render(document.querySelector('#react-app'), browserHistory);
  checkDeprecated(Config.get('VERSION'));
});
